<p-table 
    #dt 
    [loading]="loading" 
    [value]="mezzi" 
    responsiveLayout="stack" 
    [breakpoint]="'960px'"
    styleClass="scheda-tabella p-datatable-sm" 
    [paginator]="false" 
    [showCurrentPageReport]="true" 
    [rowHover]="true" 
    [globalFilterFields]="['tipo', 'targa', 'azienda']" 
    currentPageReportTemplate="{first} di {last} su {totalRecords} mezzi di trasporto" 
    [rows]="5" [rowsPerPageOptions]="[5, 10, 20, 50]">            
    <ng-template pTemplate="caption">
        <div class="flex lg:flex-row flex-col gap-3 w-full">
            <div class="lg:w-3/4 w-full">
                <p-iconfield iconPosition="left" [style]="{'width': '100%'}">
                    <p-inputicon styleClass="bi bi-search" />
                    <input type="text" pInputText (input)="onGlobalFilter(dt, $event)" placeholder="Cerca mezzo…" [style]="{'width': '100%'}" />
                </p-iconfield>
            </div>
            <div class="lg:w-1/4 w-full table-toolbar-btns">                    
                <button class="flex-1 acc-btn" type="button" (click)="add = true">                
                    <i class="bi bi-plus"></i>
                    Aggiungi
                </button>
            </div>
        </div>            
    </ng-template>
    <ng-template pTemplate="header">
        <tr>                    
            <th pSortableColumn="tipo" class="w-4/12">Tipo <span class="inline-flex"><p-sortIcon field="tipo" /></span></th>
            <th pSortableColumn="targa" class="w-2/12">Targa <span class="inline-flex"><p-sortIcon field="targa" /></span></th>
            <th pSortableColumn="azienda" class="w-4/12">Ditta <span class="inline-flex"><p-sortIcon field="azienda" /></span></th>
            <th class="w-2/12 text-center">Azioni</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-mezzo>
        <tr>
            <td>
                <span class="p-column-title">Tipo</span>
                <span class="cell-nome">{{mezzo.tipologia}}</span>
            </td>
            <td>
                <span class="p-column-title">Targa</span>
                {{mezzo.targa}}
            </td>
            <td>
                <span class="p-column-title">Ditta</span>
                {{mezzo.ditta}}
            </td>
            <td class="text-center">
                <span class="p-column-title">Azioni</span>
                <div class="table-actions">                                      
                    <i class="bi bi-pencil" (click)="onOpenEdit(mezzo)" title="Modifica"></i>                        
                    <p-divider layout="vertical"></p-divider>
                    <p-confirmpopup #delete>
                        <ng-template pTemplate="headless" let-message>
                            <div class="border-round p-3">
                                <span class="text-base">{{ message.message }}</span>
                                <div class="flex align-items-center gap-2 mt-3">
                                    <button type="button" class="acc-btn acc-btn-ghost flex-1"  (click)="onClose()">Annulla</button>
                                    <button type="button" class="acc-btn flex-1" (click)="onDelete()">Elimina</button>                                            
                                </div>
                            </div>
                        </ng-template>
                    </p-confirmpopup>
                    <i class="bi bi-trash" (click)="onOpenDelete($event, mezzo)" title="Elimina"></i>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4">Nessun mezzo di trasporto trovato.</td>
        </tr>
    </ng-template>
</p-table>

<app-add-mezzo-trasporto-accrediti-backoffice [visible]="add" [evento]="evento" (close)="add = false" />
<app-edit-mezzo-trasporto-accrediti-backoffice *ngIf="mezzo" [visible]="edit" [mezzo_trasporto]="mezzo" (close)="onCloseEdit($event)" />
